import React, { useEffect, useState } from "react";
import { InfoCard } from "../components/InfoCard";

import {
  FaRegCalendar,
  FaRegClock,
  FaFileAlt,
  FaFileImport,
  FaPlus,
  FaPen,
} from "react-icons/fa";
import {
  FaIdCard,
  FaExclamationTriangle,
  FaExclamationCircle,
  FaTimesCircle,
  FaUserLock,
} from "react-icons/fa";

import { Link } from "react-router-dom";
import TenantLink from "../components/TenantLink";
import { Breadcrumb, Button, Calendar, Modal, Typography, Tag } from "antd";
import { useAxiosPost } from "../hooks/useAxios";
import { getCardsData, getNoticeDetails, postData } from "../api/apiService";
import { toast } from "react-toastify";
import Calender from "../components/Calender";
import {
  ACTIVE_CLIENTS_TEXT,
  DISABLED_CLIENTS_TEXT,
  DUE_7_DAYS_TEXT,
  FAILED_LOGIN_TEXT,
  LAST_24_hours_TEXT,
  OPEN_NOTICES_TEXT,
  OVER_DUE_NOTICES_TEXT,
  TOTAL_NOTICE_TEXT,
} from "../utils/constants";
import AddClientModal from "../components/AddClientModal";
import BulkAssignDialog from "../components/BulkAssignDialog";
import moment from "moment";
import {
  FileTextOutlined,
  SyncOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { getClientDocType } from "../utils/helpers";
import { CLIENTS, DASHBOARD } from "../api/endpointMap";
import useTenantNavigate from "../hooks/useTenantNavigate";
import { useAuth } from "../context/AuthContext";
import { useEmbedToken } from "../context/EmbedTokenContext";

const { Text, Title } = Typography;
export const IncomeTax = ({ serviceType }) => {
  const navigate = useTenantNavigate();
  const { user: currentUser } = useAuth();
  // R71 — Hide Add / Import affordances inside /embed/* iframe (Zoho
  // partner syncs clients directly via partner API; these buttons
  // don't apply and would confuse the partner-tenant user).
  const { claims: embedClaims } = useEmbedToken();
  const isTenantAdmin =
    currentUser?.role === "tenant_admin" ||
    currentUser?.role === "super_admin";
  const [cardsData, setCardsData] = useState(null);
  const [openClientModal, setOpenClientModal] = useState(false);
  const [bulkAssignOpen, setBulkAssignOpen] = useState(false);
  const [addNewClient] = useAxiosPost(CLIENTS.CREATE_INCOME_TAX);
  const [checkingRunningImport, setCheckingRunningImport] = useState(false);
  const [runningImportModal, setRunningImportModal] = useState(false);
  const [runningImportData, setRunningImportData] = useState(null);

  const [fetchIncomeTaxCards] = useAxiosPost(
    DASHBOARD.INCOME_TAX_CARDS
  );

  const [loading, setLoading] = useState(true);

  const getData = async () => {
    try {
      const data = await getCardsData(DASHBOARD.INCOME_TAX_CARDS);
      setCardsData(data?.data || {});
    } catch (err) {
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const checkRunningImport = async () => {
    setCheckingRunningImport(true);
    try {
      const doctype = getClientDocType(serviceType);
      // Legacy `POST /api/v1/clients/import/status` with {doctype} returns 405
      // on FastAPI — that path is GET-only and expects `data_import_id`.
      // Use working `GET /api/v1/clients/import/last?doctype=<X>` which
      // returns the most recent import for this doctype; if its status is
      // Pending/Processing, a run is in flight and we show the modal.
      const response = await getNoticeDetails(
        `/api/v1/clients/import/last?doctype=${encodeURIComponent(doctype)}`
      );
      const lastImport = response?.message?.data;
      const isRunning =
        lastImport && ["Pending", "Processing"].includes(lastImport.status);

      if (isRunning) {
        setTimeout(() => {
          // Shape to what the modal (lines 334-373) renders:
          // runningImportData.imports[].{status, data_import, user, started_at}
          setRunningImportData({
            imports: [
              {
                status: lastImport.status,
                data_import: lastImport.file_name || lastImport.id,
                user: "-",
                started_at: lastImport.created_at,
              },
            ],
          });
          setRunningImportModal(true);
        }, 1000);
      } else {
        setTimeout(() => {
          navigate("/income-tax/clients?type=active&import=true");
        }, 1000);
      }
    } catch (err) {
      console.error("Error checking running import:", err);
      toast.error("Failed to check import status. Please try again.");
    } finally {
      setTimeout(() => {
        setCheckingRunningImport(false);
      }, 1000);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleAddClient = async (payload) => {
    try {
      addNewClient({
        payload,
        cb: (data, msg) => {
          if (data == null) {
            toast.error(msg ?? "Error in creatung client");
            setOpenClientModal(false);
          } else {
            setOpenClientModal(false);
            toast.info("Added Client Successfully", {
              position: "top-right",
              autoClose: 5000,
            });
            navigate("/income-tax/clients?type=active");
          }
        },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  useEffect(() => {}, []);
  return (
    <div className="p-6 bg-gray-100 ">
      <div className="flex justify-between w-full">
        <Breadcrumb
          items={[
            {
              title: (
                <TenantLink
                  className="exempt-from-readonly"
                  to={{
                    pathname: "/",
                  }}
                >
                  Home
                </TenantLink>
              ),
            },
            {
              title: "Income Tax",
            },
          ]}
          style={{
            marginBottom: "10px",
            color: "#151c40",
          }}
        />
        <div className="flex gap-4">
          {!embedClaims && (
            <>
              <Button
                onClick={() => {
                  setOpenClientModal(true);
                }}
                variant="outlined"
                icon={<FaPlus />}
                type="primary"
              >
                Add Income Tax Client
              </Button>

              <Button
                onClick={() => {
                  checkRunningImport();
                }}
                variant="outlined"
                icon={<FaFileImport />}
                type="primary"
                loading={checkingRunningImport}
              >
                Import Client
              </Button>
            </>
          )}

          <Button
            onClick={() => {
              navigate("/income-tax/clients?type=active");
            }}
            variant="outlined"
            icon={<FaPen />}
            type="primary"
          >
            Edit Client
          </Button>

          <Button
            onClick={() => setBulkAssignOpen(true)}
            variant="outlined"
            icon={<TeamOutlined />}
            type="primary"
            style={isTenantAdmin ? undefined : { display: "none" }}
          >
            Bulk Assign
          </Button>
          {/* <Button
            type="primary"
            icon={<FaFileImport />}
            // onClick={openImportClientModal}
          >
            Import Clients
          </Button> */}
        </div>
      </div>

      <h2 className="text-xl font-bold text-blue-900 mb-4">Income Tax</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Cards Section */}
        <div className="grid grid-cols-2 lg:grid-cols-2 gap-4 mb-6">
          <InfoCard
            loading={loading}
            title={TOTAL_NOTICE_TEXT}
            count={cardsData?.total_notices || 0}
            onClick={() => navigate(`/income-tax/total-notices-clients`)}
            icon={<FaFileAlt />}
          />

          <InfoCard
            loading={loading}
            title={LAST_24_hours_TEXT}
            count={cardsData?.last_3_days || 0}
            onClick={() =>
              navigate(`/income-tax/notices?type=last_3_days_notices`)
            }
            icon={<FaRegClock />}
          />
          <InfoCard
            loading={loading}
            title={OPEN_NOTICES_TEXT}
            count={cardsData?.open_notices || 0}
            onClick={() => navigate(`/income-tax/notices?type=open_notices`)}
            icon={<FaExclamationTriangle />}
          />

          <InfoCard
            loading={loading}
            title={OVER_DUE_NOTICES_TEXT}
            count={cardsData?.over_due || 0}
            icon={<FaTimesCircle />}
            onClick={() =>
              navigate(`/income-tax/notices?type=over_due_notices`)
            }
          />

          <InfoCard
            loading={loading}
            title={DUE_7_DAYS_TEXT}
            count={cardsData?.due_within_7_days || 0}
            onClick={() =>
              navigate(`/income-tax/notices?type=due_7_days_notices`)
            }
            icon={<FaExclamationCircle />}
            className="col-span-2"
          />

          <InfoCard
            title={FAILED_LOGIN_TEXT}
            loading={loading}
            count={cardsData?.login_failed || 0}
            icon={<FaUserLock />}
            onClick={() => navigate(`/income-tax/notices?type=failed_login`)}
          />

          <InfoCard
            loading={loading}
            title={ACTIVE_CLIENTS_TEXT}
            count={cardsData?.total_active_clients || 0}
            onClick={() => navigate("clients?type=active")}
            icon={<FaIdCard />}
          />

          <InfoCard
            loading={loading}
            title={DISABLED_CLIENTS_TEXT}
            count={cardsData?.total_inactive_clients || 0}
            onClick={() => navigate("clients?type=inactive")}
            icon={<FaIdCard />}
          />
        </div>

        <Calender portal={"Income Tax"} />
      </div>

      <Modal
        title={
          <div className="flex items-center gap-2">
            <SyncOutlined spin style={{ color: "#1890ff", fontSize: "20px" }} />
            <span>Import Already in Progress</span>
          </div>
        }
        open={runningImportModal}
        onCancel={() => {
          setRunningImportModal(false);
          setRunningImportData(null);
        }}
        footer={[
          <Button
            key="close"
            type="primary"
            onClick={() => {
              setRunningImportModal(false);
              setRunningImportData(null);
            }}
          >
            OK, I'll Wait
          </Button>,
        ]}
        width={600}
        centered
      >
        <div className="py-4">
          <div className="text-center mb-4">
            <div className="mb-0">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
                <FileTextOutlined
                  style={{ fontSize: "32px", color: "#1890ff" }}
                />
              </div>
            </div>
            <Title level={4} style={{ color: "#1890ff", marginBottom: "5px" }}>
              Client Import Currently Running
            </Title>
            <Text type="secondary" style={{ fontSize: "15px" }}>
              Another client import process is currently running. Please wait
              for it to complete before starting a new import.
            </Text>
          </div>

          {runningImportData?.imports &&
            runningImportData.imports.length > 0 && (
              <div className="mb-4">
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 overflow-hidden h-50">
                  <Text
                    strong
                    className="block mb-3"
                    style={{ color: "#1890ff" }}
                  >
                    Running Import Details:
                  </Text>
                  {runningImportData.imports
                    .slice(0, 1)
                    .map((importItem, index) => (
                      <div
                        key={index}
                        className="bg-white rounded-md p-3 mb-2 border border-blue-100"
                        style={{ fontSize: "14px" }}
                      >
                        <div className="flex items-center justify-between mb-2">
                          <span className="font-semibold text-gray-700">
                            Import Name:
                          </span>
                          <Tag color="blue" icon={<SyncOutlined spin />}>
                            {importItem.status || "Running"}
                          </Tag>
                        </div>
                        <div className="space-y-1 text-gray-600">
                          <div className="flex justify-between">
                            <span>Data Import:</span>
                            <span className="font-medium text-gray-800">
                              {importItem.data_import}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span>Started By:</span>
                            <span className="font-medium text-gray-800">
                              {importItem.user}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span>Started At:</span>
                            <span className="font-medium text-gray-800">
                              {moment(importItem.started_at).format(
                                "MMMM Do YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-md">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-yellow-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <Text className="text-yellow-800">
                  <strong>Please Note:</strong> You can refresh this page or try
                  again in a few minutes. The running import must complete
                  before you can start a new one.
                </Text>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <AddClientModal
        open={openClientModal}
        handleClose={() => setOpenClientModal(false)}
        handleSubmit={handleAddClient}
        type={
          serviceType == "income-tax"
            ? "income-tax"
            : serviceType == "tds"
            ? "TDS"
            : "GST"
        }
        title={
          serviceType == "income-tax"
            ? "Income Tax"
            : serviceType == "tds"
            ? "TDS"
            : "GST"
        }
      />

      <BulkAssignDialog
        open={bulkAssignOpen}
        onClose={() => setBulkAssignOpen(false)}
        onSuccess={getData}
        portal="income-tax"
      />
    </div>
  );
};
